import React from 'react';
import { api } from './api';
import { connect } from 'react-redux';
import { message, Breadcrumb, Form, Input, InputNumber, Row, Col, Select, Checkbox, Divider, Button, DatePicker, PageHeader } from 'antd';
import queryString from 'query-string';
import moment from 'moment';
import MaskedInput from 'antd-mask-input';
import QueueAnim from 'rc-queue-anim';

const Option = Select.Option;
const FormItem = Form.Item;

class Nuevo extends React.Component {

    state = {
        disabledLogin: false,
        confirmLoading: false,
        totalDataSize: 10000,
        flag: true,
        autoCompleteLocalidades: [],
        acopiadores: [],
        acopD: 0,
        acopO: 0,
        catoneviaj: 0.00,
        prunitviaj: 0.00,
        imnetoviaj: 0.00,
        aliivaviaj: 0.00,
        impivaviaj: 0.00,
        tondifviaj: 0.00,
        tolerancia: 0.09,
        toniniviaj: 0.00,
        disposiciones: [],
    }

    async componentDidMount() {
        this.fetch({});
    }
    fetch = async (params = {}) => {
        try {

            //VIAJES
            const responseViaje = await api.viajes.get(this.props.data.numeroviaj)
            if (responseViaje.status === "success") {
                this.setState({
                    data: responseViaje.data.viaje,
                }, () => { this.selecciones() });
            } else {
                this.setState({
                    data: [],
                }, () => { this.selecciones() });
                message.error(responseViaje.message, 5);
            }


            //CONCEPTOS VALES
            const responseAcop = await api.acopiadores.getAll(queryString.stringify({
                query: '',
                limite: 10000
            }))
            if (responseAcop.status === "success") {
                this.setState({
                    acopiadores: responseAcop.data.acopiadores,
                });
            } else {
                this.setState({
                    acopiadores: [],
                });
                message.error(responseAcop.message, 5);
            }
            //FLETEROS
            const responseFlet = await api.fleteros.getAll(queryString.stringify({
                query: '',
            }))
            if (responseFlet.status === "success") {
                this.setState({
                    fleteros: responseFlet.data.fleteros,
                });
            } else {
                this.setState({
                    fleteros: [],
                });
                message.error(responseFlet.message, 5);
            }

            //CHOFERES
            const responseChof = await api.choferes.get(this.state.data.cproveviaj)
            if (responseChof.status === "success") {
                this.setState({
                    choferes: responseChof.data.choferes,
                });
            } else {
                this.setState({
                    choferes: [],
                });
                message.error(responseChof.message, 5);
            }

            //CLIENTES
            // const responseCam = await api.camiones.getAll(this.props.fletero_id&&this.props.fletero_id)
            const responseCli = await api.clientes.getAll()
            if (responseCli.status === "success") {
                this.setState({
                    clientes: responseCli.data.clientes,
                });
            } else {
                this.setState({
                    clientes: [],
                });
                message.error(responseCli.message, 5);
            }

            //CAMIONES
            // const responseCam = await api.camiones.getAll(this.props.fletero_id&&this.props.fletero_id)
            const responseCam = await api.camiones.getAll(this.props.id)
            if (responseCam.status === "success") {
                this.setState({
                    camiones: responseCam.data.camiones,
                });
            } else {
                this.setState({
                    camiones: [],
                });
                message.error(responseCam.message, 5);
            }

            //MERCADERIAS
            const responseMer = await api.mercaderias.getAll()
            if (responseMer.status === "success") {
                this.setState({
                    mercaderias: responseMer.data.mercaderias,
                });
            } else {
                this.setState({
                    mercaderias: [],
                });
                message.error(responseMer.message, 5);
            }

            //DISPOSICIONES
            const responseDisp = await api.disposiciones.getAll(queryString.stringify({
                query: '',
            }))
            if (responseDisp.status === "success") {
                this.setState({
                    disposiciones: responseDisp.data.disposiciones,
                });
            } else {
                this.setState({
                    disposiciones: [],
                });
                message.error(responseDisp.message, 5);
            }

            //ALICUOTAS
            const responseIVA = await api.alicuotas.getAll()
            if (responseIVA.status === "success") {
                const i = responseIVA.data.alicuotas.findIndex(item => item.codigoalic === 5);
                this.setState({
                    alicuotas: responseIVA.data.alicuotas,
                    alicuota: responseIVA.data.alicuotas[i],
                    aliivaviaj: parseFloat(responseIVA.data.alicuotas[i].alicuoalic)
                });
                this.props.form.setFieldsValue({
                    aliivaviaj: responseIVA.data.alicuotas[i].alicuoalic
                })
            } else {
                this.setState({
                    alicuotas: [],
                });
                message.error(responseIVA.message, 5);
            }

            // this.setState({data: this.props.data}, ()=> {this.selecciones()})

        } catch (e) {
            message.error(e.toString(), 7);
        }
    }

    selecciones = () => {
        this.selectAcop(parseInt(this.state.data.cacoriviaj), "origen");
        this.selectAcop(parseInt(this.state.data.cacdesviaj), "destino");
        this.props.form.setFieldsValue({
            catoneviaj: parseFloat(this.state.data.catoneviaj),
            toniniviaj: parseFloat(this.state.data.toniniviaj),
        })
        this.setState({
            catoneviaj: this.state.data.catoneviaj,
            toniniviaj: this.state.data.toniniviaj,
            prunitviaj: parseFloat(this.state.data.prunitviaj),
            aliivaviaj: this.state.data.aliivaviaj,
            impivaviaj: parseFloat(this.state.data.impivaviaj),
            tondifviaj: parseFloat(this.state.data.tondifviaj),
            isfactndif: this.state.data.isfactndif == "0" ? false : true
        }, () => { this.calculos() })
    }

    handleLocalidades = async (value) => {

        this.setState({
            localidades: null,
        })
        if (value.trim().length >= 3) {
            try {
                this.setState({ fetchingLocalidad: true });
                const response = await api.localidades.getAll(queryString.stringify({
                    query: value.trim(),
                }))

                this.setState({
                    autoCompleteLocalidades: response.data.localidades ? response.data.localidades.map((data, index) => {
                        return {
                            text: `${data.nombrlocal} - ${data.nombrepcia}`,
                            value: `${data.codiglocal}`,
                        }
                    }) : [],
                    fetchingLocalidad: false,
                });

            } catch (e) {
                message.error(e.toString(), 7);
            }
        } else if (value.trim().length === 0) {
            this.setState({ autoCompleteLocalidades: [] })
        }
    }

    onSelectLoc(e) {
        this.setState({ localidad: e })
    }


    handleSubmit = (e) => {
        this.props.form.validateFields(async (err, values) => {
            if (!err) {
                try {
                    this.setState({
                        confirmLoading: true,
                    })
                    const response = await api.viajes.update({
                        ...values,
                        conaforo: '',
                        fecha_viaj: moment.parseZone(values.fecha_viaj).format("DD/MM/YYYY"),
                        corigeviaj: this.state.Oacop ? this.state.Oacop[0].colocaacop : '',
                        cpciaoviaj: this.state.Oacop ? this.state.Oacop[0].cproviacop : '',
                        cpaisoviaj: this.state.Oacop ? this.state.Oacop[0].copaisacop : '',

                        cdestiviaj: this.state.Dacop ? this.state.Dacop[0].colocaacop : '',
                        cpciadviaj: this.state.Dacop ? this.state.Dacop[0].cproviacop : '',
                        cpaisdviaj: this.state.Dacop ? this.state.Dacop[0].copaisacop : '',

                        remitoviaj: '',
                        pcomisviaj: "0.00",
                        icomisviaj: "0.00",
                        netscoviaj: "0.00",
                        cproveviaj: this.state.data.cproveviaj,
                        numeroviaj: this.props.data.numeroviaj,
                        codempviaj:1,
                        tondifviaj: this.state.tondifviaj, // diferencia de toneladas
                        isfactndif: this.state.isfactndif == false ? "0" : "1" //valor del check mandar 0-1
                    });
                    if (response.status === "success") {
                        this.props.closeModalFetch()
                    } else {
                        message.error(response.message, 7);
                    }
                } catch (e) {
                    message.error(e.toString(), 7);
                } finally {
                    this.setState({
                        confirmLoading: false,
                    })
                }
            }
        })
    }

    selectAcop = async (e, tipo) => {
        if (tipo === 'origen') {
            this.setState({ acopO: e })
            const responseOri = await api.acopiadores.get(e)
            if (responseOri.status === "success") {
                this.setState({
                    Oacop: responseOri.data.acopiador,
                });
            } else {
                this.setState({
                    Oacop: [],
                });
                message.error(responseOri.message, 5);
            }
        } else {
            const responseDes = await api.acopiadores.get(e)
            if (responseDes.status === "success") {
                this.setState({
                    Dacop: responseDes.data.acopiador,
                });
            } else {
                this.setState({
                    Dacop: [],
                });
                message.error(responseDes.message, 5);
            }
            this.setState({ acopD: e })
        }
    }

    subtotal = async (e, tipo) => {
        if (isNaN(e)) {
            e = 0.00
        }
        var tonin = this.props.form.getFieldValue("catoneviaj")
        this.props.form.setFieldsValue({
            imnetoviaj: parseFloat(tonin) * e
        })
    }

    comision = async (e, tipo) => {
        if (isNaN(e)) {
            e = 0.00
        }
        var subtotal = this.props.form.getFieldValue("imnetoviaj")
        var importecomis = parseFloat(subtotal) * (e / 100)
        this.props.form.setFieldsValue({
            icomisviaj: importecomis,
            netscoviaj: (subtotal - importecomis)
        })
    }

    importeiva = async (e, tipo) => {
        if (isNaN(e)) {
            e = 0.00
        }
        var neto = this.props.form.getFieldValue("netscoviaj")
        var importeiva = parseFloat(neto * (e / 100))
        const i = this.state.alicuotas.findIndex(item => item.codigoalic == e);
        this.setState({
            alicuota: this.state.alicuotas[i],
        });
        this.props.form.setFieldsValue({
            impivaviaj: importeiva,
            itotalviaj: (neto + importeiva)
        })

    }

    calculos = async () => {
        var toneladasiniciales = parseFloat(this.state.toniniviaj) 
        var tonfinales = parseFloat(this.state.catoneviaj) 
        var preunit = parseFloat(this.state.prunitviaj)
        var neto = parseFloat(this.state.imnetoviaj)
        var aliciva = parseFloat(this.state.aliivaviaj)
        var importeiva = parseFloat(this.state.impivaviaj)
        var tolerancia = this.state.tolerancia
        if (isNaN(tonfinales)) {
            tonfinales = 0
        }
        if (isNaN(preunit)) {
            preunit = 0
        }
        if (isNaN(neto)) {
            neto = 0
        }
        if (isNaN(importeiva)) {
            importeiva = 0
        }
        var importeneto = 0.00
        var importeivatot = 0.00
        var importetotal = 0.00
        var diferenciatoneladas = 0.00

        importeneto = tonfinales * preunit
        importeivatot = importeneto * (aliciva / 100)
        importetotal = importeneto + importeivatot
        diferenciatoneladas = toneladasiniciales - tonfinales - tolerancia

        if (diferenciatoneladas > 0) {

        } else {
            this.setState({ isfactndif: false })
        }

        this.setState({
            imnetoviaj: Number(importeneto).toFixed(2),
            impivaviaj: Number(importeivatot).toFixed(2),
            itotalviaj: Number(importetotal).toFixed(2),
            tondifviaj: Number(diferenciatoneladas).toFixed(2),
        }, () => {
            this.props.form.setFieldsValue({
                imnetoviaj: Number(importeneto).toFixed(2),
                impivaviaj: Number(importeivatot).toFixed(2),
                itotalviaj: Number(importetotal).toFixed(2),
                tondifviaj: Number(diferenciatoneladas).toFixed(2)
            })
        })
    }

    render() {
        console.log("PROPS: => ", this.props)
        console.log("state: => ", this.state)
        const { getFieldDecorator } = this.props.form;
        return (
            <div className="container-fluid no-breadcrumb">
                <QueueAnim type="bottom" className="ui-animate">
                    <Breadcrumb>
                        <Breadcrumb.Item href='#'>Inicio</Breadcrumb.Item>
                        <Breadcrumb.Item href="#/app/viajes">Viajes</Breadcrumb.Item>
                        <Breadcrumb.Item>Nuevo</Breadcrumb.Item>
                    </Breadcrumb>
                    <div className="box box-default box-ant-table-v1" style={{ marginTop: 15 }}>
                        <div className="box-body">
                            <PageHeader
                                onBack={() => this.props.closeModal()}
                                title={`Viaje N° ${this.props.data.numeroviaj}`} subTitle="Editar"
                            />
                            <Divider />
                            <Form style={{ marginTop: 10 }}>
                                <Row gutter={8} >
                                    <Col span={24}>
                                        <FormItem label="Fecha" {...{
                                            labelCol: { sm: { span: 4 }, },
                                            wrapperCol: { sm: { span: 4 }, },
                                        }}>
                                            {getFieldDecorator('fecha_viaj', {
                                                initialValue: this.state.data ? moment.parseZone(this.state.data.fecha_viaj) : moment().startOf('day'),
                                                // initialValue: this.state.data && this.state.data.fecha_viaj,
                                                rules: [{ required: true, message: "Fecha es obligatorio" }],
                                            })(
                                                <DatePicker format={"DD/MM/YYYY"} placeholder="Fecha" />
                                                // <Input readOnly />
                                            )}
                                        </FormItem>
                                    </Col>
                                </Row>
                                <Divider>Orígen</Divider>
                                <Row gutter={8} >
                                    <Col span={24}>
                                        <FormItem label="Acopiador" {...{
                                            labelCol: { sm: { span: 4 }, },
                                            wrapperCol: { sm: { span: 14 }, },
                                        }}>
                                            {getFieldDecorator('cacoriviaj', {
                                                initialValue: this.state.data ? parseInt(this.state.data.cacoriviaj) : '',
                                                rules: [{ required: true, message: "Este campo es requerido" }],
                                            })(
                                                <Select
                                                    style={{ width: "100%" }}
                                                    placeholder="Seleccionar"
                                                    optionFilterProp="children"
                                                    showSearch
                                                    onSelect={(e) => this.selectAcop(e, 'origen')}
                                                    filterOption={(input, option) =>
                                                        (Array.isArray(option.props.children) ? option.props.children.join("") : String(option.props.children || "")).toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                    }
                                                >
                                                    {this.state.acopiadores && this.state.acopiadores.map((data, index) => {
                                                        // return <Option value={parseInt(data.codigoacop)} disabled={parseInt(data.codigoacop) === this.state.acopD ? true : false} key={index}>{data.rasociacop}</Option>
                                                        return <Option value={parseInt(data.codigoacop)} key={index}>{data.rasociacop}</Option>
                                                    })}
                                                </Select>
                                            )}
                                        </FormItem>
                                    </Col>
                                </Row>
                                <Row gutter={8}>
                                    <Col span={12}>
                                        <FormItem label="Localidad" {...{
                                            labelCol: { sm: { span: 8 }, },
                                            wrapperCol: { sm: { span: 16 }, },
                                        }}>
                                            {getFieldDecorator('origen', {
                                                initialValue: this.state.Oacop && this.state.Oacop[0].nombrlocal,
                                                rules: [{ required: false, message: "Este campo es requerido" }],
                                            })(
                                                <Input />
                                            )}
                                        </FormItem>
                                    </Col>
                                    <Col span={12}>
                                        <FormItem label="Provincia" {...{
                                            labelCol: { sm: { span: 5 }, },
                                            wrapperCol: { sm: { span: 19 }, },
                                        }}>
                                            {getFieldDecorator('pciao', {
                                                initialValue: this.state.Oacop && this.state.Oacop[0].nombrepcia,
                                                rules: [{ required: false, message: "Este campo es requerido" }],
                                            })(
                                                <Input />
                                            )}
                                        </FormItem>
                                    </Col>
                                </Row>
                                <Divider>Destino</Divider>
                                <Row gutter={8} >
                                    <Col span={24}>
                                        <FormItem label="Acopiador" {...{
                                            labelCol: { sm: { span: 4 }, },
                                            wrapperCol: { sm: { span: 14 }, },
                                        }}>
                                            {getFieldDecorator('cacdesviaj', {
                                                initialValue: this.state.data ? parseInt(this.state.data.cacdesviaj) : '',
                                                rules: [{ required: true, message: "Este campo es requerido" }],
                                            })(
                                                <Select
                                                    style={{ width: "100%" }}
                                                    placeholder="Seleccionar"
                                                    optionFilterProp="children"
                                                    showSearch
                                                    onSelect={(e) => this.selectAcop(e, 'destino')}
                                                    filterOption={(input, option) =>
                                                        (Array.isArray(option.props.children) ? option.props.children.join("") : String(option.props.children || "")).toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                    }
                                                >
                                                    {this.state.acopiadores && this.state.acopiadores.map((data, index) => {
                                                        // return <Option value={parseInt(data.codigoacop)} disabled={parseInt(data.codigoacop) === this.state.acopO ? true : false} key={index}>{data.rasociacop}</Option>
                                                        return <Option value={parseInt(data.codigoacop)} key={index}>{data.rasociacop}</Option>
                                                    })}
                                                </Select>
                                            )}
                                        </FormItem>
                                    </Col>
                                </Row>
                                <Row gutter={8}>
                                    <Col span={12}>
                                        <FormItem label="Localidad" {...{
                                            labelCol: { sm: { span: 8 }, },
                                            wrapperCol: { sm: { span: 16 }, },
                                        }}>
                                            {getFieldDecorator('destino', {
                                                initialValue: this.state.Dacop && this.state.Dacop[0].nombrlocal,
                                                rules: [{ required: false, message: "Este campo es requerido" }],
                                            })(
                                                <Input />
                                            )}
                                        </FormItem>
                                    </Col>
                                    <Col span={12}>
                                        <FormItem label="Provincia" {...{
                                            labelCol: { sm: { span: 5 }, },
                                            wrapperCol: { sm: { span: 19 }, },
                                        }}>
                                            {getFieldDecorator('pciad', {
                                                initialValue: this.state.Dacop && this.state.Dacop[0].nombrepcia,
                                                rules: [{ required: false, message: "Este campo es requerido" }],
                                            })(
                                                <Input />
                                            )}
                                        </FormItem>
                                    </Col>
                                </Row>
                                <Divider />
                                <Row gutter={8} >
                                    <Col span={12}>
                                        <FormItem label="Cliente" {...{
                                            labelCol: { sm: { span: 6 }, },
                                            wrapperCol: { sm: { span: 18 }, },
                                        }}>
                                            {getFieldDecorator('cclienviaj', {
                                                initialValue: this.state.data ? parseInt(this.state.data.cclienviaj) : '',
                                                rules: [{ required: true, message: "Este campo es requerido" }],
                                            })(
                                                <Select
                                                    style={{ width: "100%" }}
                                                    placeholder="Seleccionar"
                                                    optionFilterProp="children"
                                                    showSearch
                                                    // onSelect={(e) => this.selectAcop(e, 'destino')}
                                                    filterOption={(input, option) =>
                                                        (Array.isArray(option.props.children) ? option.props.children.join("") : String(option.props.children || "")).toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                    }
                                                >
                                                    {this.state.clientes && this.state.clientes.map((data, index) => {
                                                        return <Option value={parseInt(data.codigoclie)} key={index}>{data.rasociclie}</Option>
                                                    })}
                                                </Select>
                                            )}
                                        </FormItem>
                                    </Col>
                                    <Col span={12}>
                                        <FormItem label="Mercadería" {...{
                                            labelCol: { sm: { span: 6 }, },
                                            wrapperCol: { sm: { span: 18 }, },
                                        }}>
                                            {getFieldDecorator('celemeviaj', {
                                                initialValue: this.state.data ? parseInt(this.state.data.celemeviaj) : '',
                                                rules: [{ required: true, message: "Este campo es requerido" }],
                                            })(
                                                <Select
                                                    style={{ width: "100%" }}
                                                    placeholder="Seleccionar"
                                                    optionFilterProp="children"
                                                    showSearch
                                                    // onSelect={(e) => this.selectAcop(e, 'destino')}
                                                    filterOption={(input, option) =>
                                                        (Array.isArray(option.props.children) ? option.props.children.join("") : String(option.props.children || "")).toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                    }
                                                >
                                                    {this.state.mercaderias && this.state.mercaderias.map((data, index) => {
                                                        return <Option value={parseInt(data.codigomerc)} key={index}>{data.descrimerc}</Option>
                                                    })}
                                                </Select>
                                            )}
                                        </FormItem>
                                    </Col>
                                </Row>
                                <Row gutter={8} >
                                    <Col span={12}>
                                        <FormItem label="Chofer" {...{
                                            labelCol: { sm: { span: 6 }, },
                                            wrapperCol: { sm: { span: 18 }, },
                                        }}>
                                            {getFieldDecorator('cchofeviaj', {
                                                initialValue: this.state.data ? parseInt(this.state.data.cchofeviaj) : '',
                                                rules: [{ required: true, message: "Este campo es requerido" }],
                                            })(
                                                <Select
                                                    style={{ width: "100%" }}
                                                    placeholder="Seleccionar"
                                                    optionFilterProp="children"
                                                    showSearch
                                                    // onSelect={(e) => this.selectAcop(e, 'destino')}
                                                    filterOption={(input, option) =>
                                                        (Array.isArray(option.props.children) ? option.props.children.join("") : String(option.props.children || "")).toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                    }
                                                >
                                                    {this.state.choferes && this.state.choferes.map((data, index) => {
                                                        return <Option value={parseInt(data.codigochof)} key={index}>{data.nombrechof}</Option>
                                                    })}
                                                </Select>
                                            )}
                                        </FormItem>
                                    </Col>
                                </Row>
                                <Row gutter={8} >
                                    <Col span={12}>
                                        <FormItem label="Dom. Camión" {...{
                                            labelCol: { sm: { span: 6 }, },
                                            wrapperCol: { sm: { span: 18 }, },
                                        }}>
                                            {getFieldDecorator('patcamviaj', {
                                                initialValue: this.state.data && this.state.data.patcamviaj !== "" ? this.state.data.patcamviaj : '',
                                                rules: [{ required: false, message: "Este campo es requerido" }],
                                            })(
                                                <Select
                                                    style={{ width: "100%" }}
                                                    placeholder="Seleccionar"
                                                    optionFilterProp="children"
                                                    showSearch
                                                    // onSelect={(e) => this.selectAcop(e, 'destino')}
                                                    filterOption={(input, option) =>
                                                        (Array.isArray(option.props.children) ? option.props.children.join("") : String(option.props.children || "")).toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                    }
                                                >
                                                    {this.state.camiones && this.state.camiones.map((data, index) => {
                                                        return <Option value={data.dominicami} key={index}>{data.dominicami}</Option>
                                                    })}
                                                </Select>
                                            )}
                                        </FormItem>
                                    </Col>
                                    <Col span={12}>
                                        <FormItem label="Dom. Acoplado" {...{
                                            labelCol: { sm: { span: 6 }, },
                                            wrapperCol: { sm: { span: 18 }, },
                                        }}>
                                            {getFieldDecorator('patacoviaj', {
                                                initialValue: this.state.data && this.state.data.patacoviaj !== "" ? this.state.data.patacoviaj : '',
                                                rules: [{ required: false, message: "Este campo es requerido" }],
                                            })(
                                                <Select
                                                    style={{ width: "100%" }}
                                                    placeholder="Seleccionar"
                                                    optionFilterProp="children"
                                                    showSearch
                                                    filterOption={(input, option) =>
                                                        (Array.isArray(option.props.children) ? option.props.children.join("") : String(option.props.children || "")).toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                    }
                                                >
                                                    {this.state.camiones && this.state.camiones.map((data, index) => {
                                                        return <Option value={data.dominiacop} key={index}>{data.dominiacop}</Option>
                                                    })}
                                                </Select>
                                            )}
                                        </FormItem>
                                    </Col>
                                </Row>
                                <Row gutter={8}>
                                    <Col span={12}>
                                        <FormItem label="CTG/Remito" {...{
                                            labelCol: { sm: { span: 8 }, },
                                            wrapperCol: { sm: { span: 16 }, },
                                        }}>
                                            {getFieldDecorator('cartaporte', {
                                                initialValue: this.state.data ? this.state.data.cartaporte : '',
                                                rules: [{ required: true, message: "Este campo es requerido" }],
                                            })(
                                                <MaskedInput
                                                    mask="1111-11111111"
                                                    name="card"
                                                />
                                            )}
                                        </FormItem>
                                    </Col>
                                    <Col span={12}>
                                    </Col>
                                </Row>
                                <Divider />
                                <Row gutter={8}>
                                    <Col span={8}>
                                        <FormItem label="Cant. Inicial" {...{
                                            labelCol: { sm: { span: 8 }, },
                                            wrapperCol: { sm: { span: 15 }, },
                                        }}>
                                            {getFieldDecorator('toniniviaj', {
                                                initialValue: this.state.data ? parseInt(this.state.data.toniniviaj) : '',
                                                rules: [{ required: true, message: "Este campo es requerido" }],
                                            })(
                                                <InputNumber
                                                    min={0}
                                                    style={{width:'100%'}}
                                                    readOnly={(Number(this.props.data.liquidadoc) === 0 && Number(this.props.data.liquidadof) === 0) ? false : true}
                                                    onChange={(e) => { this.setState({ toniniviaj: e }, () => this.calculos()) }}
                                                />
                                            )}
                                        </FormItem>
                                    </Col>
                                    <Col span={8}>
                                        <FormItem label="Cant. Final" {...{
                                            labelCol: { sm: { span: 8 }, },
                                            wrapperCol: { sm: { span: 16 }, },
                                        }}>
                                            {getFieldDecorator('catoneviaj', {
                                                initialValue: this.state.data ? parseInt(this.state.data.catoneviaj) : '',
                                                rules: [{ required: false, message: "Este campo es requerido" }],
                                            })(
                                                <InputNumber
                                                    min={0}
                                                    style={{width:'100%'}}
                                                    onChange={(e) => { this.setState({ catoneviaj: e }, () => this.calculos()) }}
                                                    step={0.1}
                                                    readOnly={(Number(this.props.data.liquidadoc) === 0 && Number(this.props.data.liquidadof) === 0) ? false : true}
                                                />
                                            )}
                                        </FormItem>
                                    </Col>
                                    <Col span={8}>
                                        <FormItem label="Disposición" {...{
                                            labelCol: { sm: { span: 9 }, },
                                            wrapperCol: { sm: { span: 15 }, },
                                        }}>
                                            {getFieldDecorator('iddisposicion', {
                                                initialValue: this.state.data ? this.state.data.iddisposicion : '',
                                                rules: [{ required: true, message: "Este campo es requerido" }],
                                            })(
                                                <Select
                                                    style={{ width: "100%" }}
                                                    placeholder="Seleccionar"
                                                    optionFilterProp="children"
                                                    showSearch
                                                    filterOption={(input, option) =>
                                                        (Array.isArray(option.props.children) ? option.props.children.join("") : String(option.props.children || "")).toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                    }
                                                >
                                                    {this.state.disposiciones && this.state.disposiciones.map((data, index) => {
                                                        return <Option value={data.id} key={index}>{`${data.desc_dispo} (${data.abrev})`}</Option>
                                                    })}
                                                </Select>
                                            )}
                                        </FormItem>
                                    </Col>
                                </Row>
                                <Row gutter={8}>
                                    <Col span={8}>
                                        <FormItem label="Precio Unit." {...{
                                            labelCol: { sm: { span: 8 }, },
                                            wrapperCol: { sm: { span: 15 }, },
                                        }}>
                                            {getFieldDecorator('prunitviaj', {
                                                initialValue: this.state.data ? parseInt(this.state.data.prunitviaj) : '',
                                                rules: [{ required: true, message: "Este campo es requerido" }],
                                            })(
                                                <InputNumber
                                                    min={0}
                                                    style={{width:'100%', float:'right'}}
                                                    formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                    parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                                    onChange={(e) => { this.setState({ prunitviaj: e }, () => this.calculos()) }}
                                                    readOnly={(Number(this.props.data.liquidadoc) === 0 && Number(this.props.data.liquidadof) === 0) ? false : true}
                                                />
                                            )}
                                        </FormItem>
                                    </Col>
                                    <Col span={8}>
                                        <FormItem label="Tolerancia" {...{
                                            labelCol: { sm: { span: 8 }, },
                                            wrapperCol: { sm: { span: 15 }, },
                                        }}>
                                            {getFieldDecorator('tolerancia', {
                                                initialValue: 0,
                                                rules: [{ required: true, message: "Este campo es requerido" }],
                                            })(
                                                <InputNumber
                                                    min={0.09}
                                                    step={0.01}
                                                    style={{width:'100%'}}
                                                    onChange={(e) => { this.setState({ tolerancia: e }, () => this.calculos()) }}
                                                    readOnly={(Number(this.props.data.liquidadoc) === 0 && Number(this.props.data.liquidadof) === 0) ? false : true}
                                                />
                                            )}
                                        </FormItem>
                                    </Col>
                                    <Col span={8}>
                                        <FormItem label="Diferencia" {...{
                                            labelCol: { sm: { span: 8 }, },
                                            wrapperCol: { sm: { span: 15 }, },
                                        }}>
                                            {getFieldDecorator('tondifviaj', {
                                                initialValue: 0,
                                                rules: [{ required: true, message: "Este campo es requerido" }],
                                            })(
                                                <InputNumber
                                                    min={0}
                                                    step={0.1}
                                                    style={{width:'100%'}}
                                                    readOnly={(Number(this.props.data.liquidadoc) === 0 && Number(this.props.data.liquidadof) === 0) ? false : true}
                                                />
                                            )}
                                        </FormItem>
                                    </Col>
                                </Row>
                                <Row gutter={8}>
                                    <Col span={16}></Col>
                                    <Col span={8}>
                                        <Checkbox
                                            checked={this.state.isfactndif}
                                            //ACA FALTA
                                            disabled={this.state.tondifviaj > 0 ? (Number(this.props.data.liquidadoc) === 0 && Number(this.props.data.liquidadof) === 0) ? true : false : true}
                                            onChange={(e) => { this.setState({ isfactndif: e.target.checked }) }}>
                                            Habilitar para facturación
                                        </Checkbox>
                                    </Col>
                                </Row>
                                <Row gutter={8}>
                                    <Col span={8}>
                                        <FormItem label="Importe Neto" {...{
                                            labelCol: { sm: { span: 8 }, },
                                            wrapperCol: { sm: { span: 16 }, },
                                        }}>
                                            {getFieldDecorator('imnetoviaj', {
                                                initialValue: 0,
                                                rules: [{ required: true, message: "Este campo es requerido" }],
                                            })(
                                                <InputNumber
                                                style={{width:'100%'}}
                                                    readOnly={(Number(this.props.data.liquidadoc) === 0 && Number(this.props.data.liquidadof) === 0) ? false : true}
                                                    min={0}
                                                    formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                    parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                                />
                                            )}
                                        </FormItem>
                                    </Col>
                                    <Col span={8}>
                                        <FormItem label="Alic. IVA" {...{
                                            labelCol: { sm: { span: 8 }, },
                                            wrapperCol: { sm: { span: 16 }, },
                                        }}>
                                            {getFieldDecorator('aliivaviaj', {
                                                initialValue: 0,
                                                rules: [{ required: true, message: "Este campo es requerido" }],
                                            })(
                                                <Select
                                                    style={{ width: "100%" }}
                                                    placeholder="Seleccionar"
                                                    disabled={(Number(this.props.data.liquidadoc) === "0" && Number(this.props.data.liquidadof) === "0") ? false : true}
                                                    onSelect={(e) => { this.setState({ aliivaviaj: parseFloat(e) }, () => this.calculos()) }}
                                                >
                                                    {this.state.alicuotas && this.state.alicuotas.map((data, index) => {
                                                        return <Option value={data.alicuoalic} key={index}>{data.descrialic}</Option>
                                                    })}
                                                </Select>
                                            )}
                                        </FormItem>
                                    </Col>
                                    <Col span={8}>
                                        <FormItem label="Importe IVA" {...{
                                            labelCol: { sm: { span: 9 }, },
                                            wrapperCol: { sm: { span: 15 }, },
                                        }}>
                                            {getFieldDecorator('impivaviaj', {
                                                initialValue: 0,
                                                rules: [{ required: true, message: "Este campo es requerido" }],
                                            })(
                                                <InputNumber
                                                    min={0}
                                                    readOnly
                                                    style={{width:'100%', float:'right'}}
                                                    formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                    parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                                />
                                            )}
                                        </FormItem>
                                    </Col>
                                </Row>
                                <Row gutter={16}>
                                    <Col span={16}></Col>
                                    <Col span={8}>
                                        <FormItem label="Importe total" {...{
                                            labelCol: { sm: { span: 9 }, },
                                            wrapperCol: { sm: { span: 15 }, },
                                        }} style={{ fontWeight: 'bold' }}>
                                            {getFieldDecorator('itotalviaj', {
                                                initialValue: 0,
                                                rules: [{ required: true, message: "Este campo es requerido" }],
                                            })(
                                                <InputNumber
                                                    min={0}
                                                    readOnly
                                                    style={{width:'100%', float:'right'}}
                                                    formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                    parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                                />
                                            )}
                                        </FormItem>
                                    </Col>
                                </Row>
                                
                                <br />
                                <Row gutter={8}>
                                    <Col span={24}>
                                        <Button
                                            type="primary"
                                            style={{ float: 'right'}}
                                            onClick={() => this.handleSubmit()}
                                        >
                                            Actualizar datos de viaje
                                        </Button>
                                    </Col>
                                </Row>
                            </Form>
                        </div>
                    </div>
                </QueueAnim>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    user: state.user,
});

const WrappedNuevo = Form.create()(Nuevo);

export default connect(
    mapStateToProps,
)(WrappedNuevo);